import { render, staticRenderFns } from "./AssignedRiskEdit.vue?vue&type=template&id=164ac905&"
import script from "./AssignedRiskEdit.vue?vue&type=script&lang=ts&"
export * from "./AssignedRiskEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VCard,VContent})
